// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1kmPa","label":"styles_label__5mhYZ","passField":"styles_passField__3My-o"};